import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    margin: theme.spacing(1, 0),
    borderLeft: `4px solid ${theme.palette.grey[200]}`,
    padding: theme.spacing(0.5, 0, 0.5, 1.5),
    '& > p:first-of-type': {
      marginTop: theme.spacing(0)
    },
    '& > p:last-child': {
      marginBottom: theme.spacing(0)
    }
  }
}));

type Props = {
  children?: React.ReactNode;
  className?: string;
};

const Blockquote = ({ children, className }: Props) => {
  const { classes, cx } = useStyles();
  return (
    <blockquote className={cx(classes.wrapper, className)}>
      {children}
    </blockquote>
  );
};

export default Blockquote;
